import React, { Component } from "react"
import { smoothSailing } from "../lib/scrolling";

export default class Fig extends Component {
  handleClick = (e, id) => {
    e.preventDefault()

    console.log(document.getElementById(id))

    smoothSailing({
      destination: document.getElementById(id),
      duration: 300,
      easing: "easeOutQuad",
      offset: 300,
      container: document.getElementsByClassName('split__panel--right')[0],
    })
  }

  render() {
    const id = `#${this.props.id}`

    return (
      <span className="fig">
        <a className="fig__link" href={id} onClick={e => this.handleClick(e, this.props.id)}>
          [{this.props.children}]
        </a>
      </span>
    )
  }
}
